import { Attachments } from 'modules/Assets/Attachments'
import { dequal } from 'dequal'
import type { ServerAsset } from '@sequencehq/api/utils/commonModels'
import {
  useSelectBillingScheduleAttachments,
  useShouldDisableModifyBillingScheduleAttachments,
  useStoreBillingScheduleAttachments
} from 'Cube/domain/subdomain/attachments'
import { useEffect, useState } from 'react'
import { useCurrentInspectorAsset } from './useCurrentInspectorAsset'
import { ASSET_ACCEPTED_MIME_TYPES } from '@sequencehq/utils'

export const BillingScheduleAttachments = ({
  defaultAttachment,
  onSelectedPreviewChange
}: {
  defaultAttachment?: ServerAsset
  onSelectedPreviewChange?: () => void
}) => {
  const attachments = useSelectBillingScheduleAttachments()
  const storeAttachments = useStoreBillingScheduleAttachments()
  const disableModifyAttachments =
    useShouldDisableModifyBillingScheduleAttachments()
  const { setCurrentInspectorAsset } = useCurrentInspectorAsset()

  const handleAttachmentChange = (assets: ServerAsset[]) => {
    if (
      !dequal(
        assets.map(({ id }) => id),
        attachments.map(({ id }) => id)
      )
    ) {
      storeAttachments(assets)
    }
  }

  const [attachmentToPreview, setAttachmentToPreview] = useState<
    ServerAsset | undefined
  >(defaultAttachment)

  const handleAllUploadsComplete = (assets: ServerAsset[]) => {
    if (assets.length !== 1) {
      return
    }

    setAttachmentToPreview(assets[0])
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: ensure current asset is cleared when inspector is closed
  useEffect(() => {
    return () => {
      setCurrentInspectorAsset(null)
    }
  }, [])

  return (
    <Attachments
      attachmentToPreview={attachmentToPreview}
      initialAttachments={attachments}
      onChange={handleAttachmentChange}
      onAllUploadsComplete={handleAllUploadsComplete}
      disableModifyAttachments={disableModifyAttachments}
      onSelectedPreviewChange={asset => {
        onSelectedPreviewChange?.()
        setCurrentInspectorAsset(asset)
      }}
      acceptedMimeTypes={ASSET_ACCEPTED_MIME_TYPES.billingSchedules}
    />
  )
}
